import { FormattedMessage } from 'react-intl'
import { Heading } from '@starbucks-web/pattern-library'
const SectionHeading = (text) => (
  <Heading className="py1 text-bold" size="xs" tagName="h2">
    <FormattedMessage {...text} />
  </Heading>
)

export default SectionHeading
